/* eslint-disable */

export default {
  en: {
    Phrase_Data_Protection: () => "Data protection",
    Phrase_Accessibility: () => "Accessibility",
    Phrase_Terms_Of_Use: () => "Terms and conditions",
    Phrase_Terms_And_Condition: () => "Terms and conditions of agreement",
    Phrase_Use_Of_Cookies: () => "Use of cookies",
    Phrase_Copyright: () => "© OP Pohjola",
    Phrase_Choose_Language_fi: () => "FI, suomeksi",
    Phrase_Choose_Language_sv: () => "SV, på svenska",
    Phrase_Choose_Language_en: () => "EN, in English",
    Phrase_Language_Changed_fi: () => "Kieli vaihdettu suomeksi",
    Phrase_Language_Changed_en: () => "Language changed to english",
    Phrase_Language_Changed_sv: () => "Språket ändrat till svenska",
    Link_Data_Protection: () => "/dataprotection",
    Link_Accessibility: () => "/accessibility/corporate-customer-webpage",
    Link_Terms_Of_Use: () => "/terms-of-use",
    Link_Terms_And_Condition: () => "/terms-and-conditions",
    Link_Use_Of_Cookies: () => "/use-of-cookies",
    Error_Generic: () => "An error occurred in the service. Please try again later.",
    Error_Notification_IL15: () => "Check the insurance card’s address.",
    Error_Notification_IL16: () => "The insurance card is no longer valid. Please contact your employer.",
    Error_Notification_IL17: () => "Ask your employer to check your insurance coverage."
  },
  fi: {
    Phrase_Data_Protection: () => "Tietosuoja",
    Phrase_Accessibility: () => "Saavutettavuus",
    Phrase_Terms_Of_Use: () => "Käyttöehdot",
    Phrase_Terms_And_Condition: () => "Sopimusehdot",
    Phrase_Use_Of_Cookies: () => "Evästeiden käyttö",
    Phrase_Copyright: () => "© OP Pohjola",
    Phrase_Choose_Language_fi: () => "FI, suomeksi",
    Phrase_Choose_Language_sv: () => "SV, på svenska",
    Phrase_Choose_Language_en: () => "EN, in English",
    Phrase_Language_Changed_fi: () => "Kieli vaihdettu suomeksi",
    Phrase_Language_Changed_en: () => "Language changed to english",
    Phrase_Language_Changed_sv: () => "Språket ändrat till svenska",
    Link_Data_Protection: () => "/tietosuoja",
    Link_Accessibility: () => "/saavutettavuus/yritysasiakkaiden-sivusto",
    Link_Terms_Of_Use: () => "/kayttoehdot",
    Link_Terms_And_Condition: () => "/ehdot",
    Link_Use_Of_Cookies: () => "/evasteiden-kaytto",
    Error_Generic: () => "Palvelussa tapahtui virhe, yritä hetken kuluttua uudestaan.",
    Error_Notification_IL15: () => "Tarkista vakuutuskortin osoite.",
    Error_Notification_IL16: () => "Vakuutuskortti ei ole enää voimassa. Ole hyvä ja ota yhteyttä työnantajaasi.",
    Error_Notification_IL17: () => "Pyydä työnantajaasi tarkistamaan vakuutusturvasi."
  },
  sv: {
    Phrase_Data_Protection: () => "Dataskydd",
    Phrase_Accessibility: () => "Tillgänglighet",
    Phrase_Terms_Of_Use: () => "Användarvillkor",
    Phrase_Terms_And_Condition: () => "Avtalsvillkor",
    Phrase_Use_Of_Cookies: () => "Användning av kakor",
    Phrase_Copyright: () => "© OP Pohjola",
    Phrase_Choose_Language_fi: () => "FI, suomeksi",
    Phrase_Choose_Language_sv: () => "SV, på svenska",
    Phrase_Choose_Language_en: () => "EN, in English",
    Phrase_Language_Changed_fi: () => "Kieli vaihdettu suomeksi",
    Phrase_Language_Changed_en: () => "Language changed to english",
    Phrase_Language_Changed_sv: () => "Språket ändrat till svenska",
    Link_Data_Protection: () => "/dataskydd",
    Link_Accessibility: () => "/tillganglighet/webbplats-for-foretagskunder",
    Link_Terms_Of_Use: () => "/anvandarvillkor",
    Link_Terms_And_Condition: () => "/villkor",
    Link_Use_Of_Cookies: () => "/cookie-anvandning",
    Error_Generic: () => "Ett fel uppstod i tjänsten, försök på nytt om en stund.",
    Error_Notification_IL15: () => "Kontrollera adressen i försäkringskortet.",
    Error_Notification_IL16: () => "Försäkringskortet är inte längre i kraft. Var god och kontakta din arbetsgivare.",
    Error_Notification_IL17: () => "Be din arbetsgivare att kontrollera ditt försäkringsskydd."
  }
}